export default function({ store, route, redirect, app }) {
  if (!store.getters.isLogin) {
    store.commit('app/setLoginPop', true)
  }
}
